var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2DD4BF",
    d: "m7.067 11.067 4.7-4.7-.934-.933L7.067 9.2l-1.9-1.9-.934.933zm.933 3.6a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 1.86 10.6 6.5 6.5 0 0 1 1.333 8q0-1.383.526-2.6a6.8 6.8 0 0 1 1.424-2.117q.9-.9 2.117-1.424A6.5 6.5 0 0 1 8 1.333q1.382 0 2.6.526 1.218.525 2.117 1.425.898.9 1.425 2.116.526 1.217.525 2.6a6.5 6.5 0 0 1-.526 2.6 6.7 6.7 0 0 1-1.424 2.117q-.902.9-2.117 1.425a6.5 6.5 0 0 1-2.6.525"
  })));
};
export default SvgTick;